import Cookies from "js-cookie";

export function clearAuthCookies() {
  [
    "jwt_token",
    "user_type",
    "userId",
    "refreshToken",
    "name",
    "first_name",
    "last_name",
    "email",
    "phone_no",
    "is_profile_completed",
    "profile_image",
    "platform_type",
    "is_dependent",
  ].forEach((cookie) => {
    Cookies.remove(cookie, { path: "/" });
    Cookies.remove(cookie);
  });
  return true;
}

const EMPTY_SNAPSHOT = {
  userId: null,
  user_type: null,
  email: null,
  first_name: null,
  last_name: null,
  phone_no: null,
  name: null,
  is_profile_completed: null,
  profile_image: null,
  isAuthenticated: false,
};

let _authSnapshot = { ...EMPTY_SNAPSHOT };

export const setAuthSnapshot = (profile = {}) => {
  _authSnapshot = { ..._authSnapshot, ...profile, isAuthenticated: true };
};

/** Clear the snapshot on logout / hard-logout. */
export const clearAuthSnapshot = () => {
  _authSnapshot = { ...EMPTY_SNAPSHOT };
};

/** @returns {string|null} server-verified user type */
export const getUserType = () => _authSnapshot.user_type || null;

/** @returns {string|null} current user id */
export const getUserId = () => _authSnapshot.userId || null;

/**
 * Whether a session is active (server-verified, in-memory). It is false until the
 * boot-time /me resolves, so route guards should use the AuthContext isLoading flag too.
 * @returns {boolean}
 */
export const isAuthenticated = () => !!_authSnapshot.isAuthenticated;

/** @returns {boolean} */
export const isAdmin = () => _authSnapshot.user_type === "admin";

/** @returns {boolean} */
export const isCustomer = () => _authSnapshot.user_type === "customer";
